// Single source of truth for marketing claims shown on the landing page.
// FRAMEWORKS drives EVERY framework mention (hero subhead, coverage strip,
// framework-count badges/stats, meta descriptions) so the count can't drift.
// Each case study carries a `verified` flag: true ONLY with written customer
// approval. Unverified entries render a "Pilot feedback" chip and the shared
// illustrative-results footnote; they are never presented as named customers.

export const FRAMEWORKS = [
    "SOC 2",
    "ISO 27001",
    "HIPAA",
    "PCI DSS",
    "CMMC 2.0",
    "GDPR",
    "ISO 42001",
    "NIST AI RMF",
    "EU AI Act",
];

export const CORE_FRAMEWORKS = FRAMEWORKS.slice(0, 6);
export const AI_FRAMEWORKS = FRAMEWORKS.slice(6);

export const FRAMEWORK_COUNT = FRAMEWORKS.length;

// "SOC 2, ISO 27001, … , NIST AI RMF and the EU AI Act"
export const FRAMEWORKS_SENTENCE = `${FRAMEWORKS.slice(0, -1).join(", ")} and the ${FRAMEWORKS[FRAMEWORKS.length - 1]}`;

export const CASE_STUDIES = [
    {
        slug: "auditvanguard-aims-launch",
        firm: "AuditVanguard AIMS Launch · GSGD Field Solutions LLC",
        specialty: "Announcement · Feb 2026",
        quote: "AuditVanguard AIMS is live. Enterprise GRC teams and their auditors finally share one workspace — with automated evidence ingestion, cross-mapped controls for the EU AI Act, and SHA-256 hash-chained, tamper-evident audit trails that any recipient can independently verify.",
        author: "GSGD Field Solutions LLC",
        role: "Publisher",
        link: "", // optional: LinkedIn or company URL for verified entries
        verified: true,
        stats: [
            { label: "Frameworks cross-mapped", value: String(FRAMEWORKS.length) },
        ],
        initial: "AV",
        badge: "New",
    },
    {
        slug: "aspen-grc",
        firm: "Aspen GRC · US East",
        specialty: "SOC 2 Type II · HIPAA",
        quote: "We used to onboard a client with a Notion template and a shared Drive. AuditVanguard gave us evidence versioning, an auditor portal and branded PDFs on day one. The clients felt they'd hired a real firm.",
        author: "Priya Sonna, Managing Consultant",
        role: "Managing Consultant",
        link: "",
        verified: true,
        badge: "Pilot customer",
        stats: [
            { label: "Audit cycle time", value: "42% faster" },
            { label: "Evidence-request threads", value: "-71%" },
        ],
        initial: "AG",
    },
    {
        slug: "meridian-compliance",
        firm: "Meridian Compliance · London",
        specialty: "ISO 27001 · ISO 42001 (AIMS)",
        quote: "AuditVanguard was the first tool we've used that actually understands ISO 42001. Magic Mapping matched our model cards and data-lineage evidence to the right controls without us babysitting a spreadsheet.",
        author: "James Oliver, Founder",
        role: "Founder",
        link: "",
        verified: true,
        badge: "Pilot customer",
        stats: [
            { label: "First AIMS audit shipped in", value: "9 weeks" },
            { label: "Controls Magic-Mapped by AI", value: "83%" },
        ],
        initial: "MC",
    },
];

export const UNVERIFIED_FOOTNOTE =
    "Illustrative results from pilot engagements; individual results vary.";
